mch365.booth = {
    const: {
        degreeInterval: 90,
        unitsPerMeter: 3,
        resizeInterval: null,
        scrollInterval: null,
        zoomMinimum: 1,
        zoomCurrent: 1,
        zoomInterval: .5,
        zoomMaximum: 5,
        canvasRatio: 3/4
    },
    variables: {
        floorplan: {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        }
    },
    jElementBoothContainer: null,
    jElementBoothCanvasContainer: null,
    jElementBoothCanvas: null,
    jElementBooth: null,
    jElementBoothCart: null,
    jElementBoothLegends: null,
    root: null,
    feed: null,
    expandedElements: [],
    originalFeedStringified: null,
    jsonChanged: false,
    panzoom: null,
    scale: 1,
    init: function () {
        if ( jQuery( '#js-mch365-booth' ).length > 0 ) {
            mch365.booth.root = document.documentElement;
            mch365.booth.jElementBoothContainer = jQuery( '.js-mch365-booth-container' );
            mch365.booth.jElementBooth = jQuery( '#js-mch365-booth' );
            mch365.booth.jElementBoothCart = jQuery( '.js-mch365-booth-cart' );
            mch365.booth.jElementBoothCanvas = jQuery( '.js-mch365-booth-guide-layer' );
            mch365.booth.jElementBoothCanvasContainer = jQuery( '.js-mch365-booth-panzoom-canvas' );
            mch365.booth.jElementBoothLegends = jQuery( '.js-mch365-booth-legends' );
            e4.require.js( e4.settings.require.handlebars, function () {
                e4.handlebars.registerHelpers( 'compare' );
                e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-booth-cart-header' );
                e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-booth-cart' );
                e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-booth-legends' );
                e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-placement-msg' );
                e4.handlebars.registerPartials( '#js-e-handlebars-tmpl-booth-item-partial' );
                e4.handlebars.registerPartials( '#js-e-handlebars-tmpl-no-booth-or-orderlines-partial' );
                mch365.booth.bindEvents();
            } );
        }
    },
    bindEvents: function () {
        
        jQuery('#js-mch365-booth-modal')
        .on('show.bs.modal', function (event) {
            jQuery('*[data-target="#js-mch365-booth-modal"]').addClass('d-none');
            if (e4.cart !== undefined){
                e4.cart.msg.hide();
            }
            jQuery('body').css('overflow', 'hidden');
        })
        .on('shown.bs.modal', function (event) {
            mch365.booth.cart.action.load();
        })
        .on('hide.bs.modal', function (event) {
            jQuery('*[data-target="#js-mch365-booth-modal"]').removeClass('d-none');
            jQuery('body').css('overflow', 'auto');
            if (mch365.booth.jsonChanged){
                jQuery('#mch365-booth-modal-warning').modal('show');
            }
        });
        
        mch365.booth.jElementBooth
        .on( 'click', '.js-mch365-rotate-item', function ( event ) {
            let jBoothItem = jQuery( event.currentTarget ).closest( '.js-mch365-booth-item' );
            let degree = jBoothItem.data( 'rotation' ) + mch365.booth.const.degreeInterval;
            degree = degree >= 360 ? 0 : degree;
            mch365.booth.item.action.rotate( jBoothItem, jBoothItem.data( 'rotation' ), degree, true );
        } )
        .on( 'click', '.js-mch365-booth-item', function ( event ) {
            let jBoothItem = jQuery( event.currentTarget );
            mch365.booth.jElementBooth.find( '.js-mch365-booth-item' ).removeClass( 'active' );
            jBoothItem.addClass( 'active' );

            mch365.booth.jElementBoothCart.find( '.js-mch365-booth-cart-item' ).removeClass( 'active' );
            mch365.booth.jElementBoothCart.find( '.js-mch365-booth-cart-item[data-orderlineid="' + jBoothItem.data( 'orderlineid' ) + '"]' ).addClass( 'active' );
        } )
        .on( 'click', function ( event ) {
            if ( jQuery( event.target ).hasClass( 'js-mch365-booth' ) ) {
                mch365.booth.jElementBooth.find( '.js-mch365-booth-item' ).removeClass( 'active' );
                mch365.booth.jElementBoothCart.find( '.js-mch365-booth-cart-item' ).removeClass( 'active' );
            }
        } );

        
        mch365.booth.jElementBoothCart
        .on( 'mouseenter', '.js-mch365-booth-cart-item', function ( event ) {
            let jBoothCartItem = jQuery( event.currentTarget ).closest( '.js-mch365-booth-cart-item' );
            mch365.booth.jElementBoothCart.find( '.js-mch365-booth-cart-item' ).removeClass( 'active' );
            jBoothCartItem.addClass( 'active' );
            mch365.booth.jElementBooth.find( '.js-mch365-booth-item' ).removeClass( 'active' );
            mch365.booth.jElementBooth.find( '.js-mch365-booth-item[data-orderlineid="' + jBoothCartItem.data( 'orderlineid' ) + '"]' ).addClass( 'active' );
        } )
        .on( 'mouseleave', '.js-mch365-booth-cart-item', function ( event ) {
            if ( jQuery( event.target ).hasClass( 'js-mch365-booth-cart' ) ) {
                mch365.booth.jElementBooth.find( '.js-mch365-booth-item' ).removeClass( 'active' );
                mch365.booth.jElementBoothCart.find( '.js-mch365-booth-cart-item' ).removeClass( 'active' );
            }
        } )
        .on( 'click', function ( event ) {
            if ( jQuery( event.target ).hasClass( 'js-mch365-booth-cart' ) ) {
                mch365.booth.jElementBooth.find( '.js-mch365-booth-item' ).removeClass( 'active' );
                mch365.booth.jElementBoothCart.find( '.js-mch365-booth-cart-item' ).removeClass( 'active' );
            }
        } )
        .on( 'click', '.js-mch365-booth-remove-item-btn', function ( event ) {
            let jBoothCartItem = jQuery( event.target ).closest( '.js-mch365-booth-cart-item' );
            let orderline = mch365.booth.item.action.getOrderline( jBoothCartItem.data( 'orderlineid' ) );
            let intIndex = mch365.booth.feed.cart.orderLines.indexOf( orderline[ 0 ] );
            mch365.booth.feed.cart.orderLines[ intIndex ].coords.x = 0;
            mch365.booth.feed.cart.orderLines[ intIndex ].coords.y = 0;
            mch365.booth.feed.cart.orderLines[ intIndex ].boothItem.x = 0;
            mch365.booth.feed.cart.orderLines[ intIndex ].boothItem.y = 0;
            mch365.booth.feed.cart.orderLines[ intIndex ].boothItem.rotation = 0;
            mch365.booth.feed.cart.orderLines[ intIndex ].comment = '';
            mch365.booth.feed.cart.orderLines[ intIndex ].placed = false;
            mch365.booth.jsonChanged = true;
            mch365.booth.container.action.calibrate();
        } )
        .on('blur', '.js-mch365-booth-cart-item-comment-input', e4.util.debounce( function ( event ) {
            let jElement = jQuery( event.target );
            let jBoothCartItem = jElement.closest( '.js-mch365-booth-cart-item' );
            let orderline = mch365.booth.item.action.getOrderline( jBoothCartItem.data( 'orderlineid' ) );
            let intIndex = mch365.booth.feed.cart.orderLines.indexOf( orderline[ 0 ] );
            mch365.booth.feed.cart.orderLines[ intIndex ].comment = jElement.val();
            mch365.booth.jsonChanged = true;
            mch365.booth.container.action.calibrate();
        }, 0 ));
        
        
        mch365.booth.jElementBoothContainer
        .on( 'click', '.js-mch365-booth-canvas-zoom', function ( event ) {
            let jElement = jQuery( event.target );
            let intZoom = jElement.data( 'direction' ) === 'in' ? mch365.booth.scale + mch365.booth.const.zoomInterval : mch365.booth.scale - mch365.booth.const.zoomInterval;

            intZoom = intZoom < mch365.booth.const.zoomMinimum ? mch365.booth.const.zoomMinimum : intZoom;
            intZoom = intZoom > mch365.booth.const.zoomMaximum ? mch365.booth.const.zoomMaximum : intZoom;

            if ( intZoom !== mch365.booth.scale ) {
                mch365.booth.container.action.zoom( intZoom );
            }
        } );

        
        mch365.booth.jElementBoothLegends
        .on( 'change', '.js-mch365-booth-toggle-layer', function ( event ) {
            let jCheckboxElement = jQuery( event.currentTarget );
            mch365.booth.jElementBooth.removeClass( 'hide-layer-' + jCheckboxElement.data( 'layer' ) );
            mch365.booth.jElementBoothCart.removeClass( 'hide-layer-' + jCheckboxElement.data( 'layer' ) );
            if ( !jCheckboxElement.is( ':checked' ) ) {
                mch365.booth.jElementBooth.addClass( 'hide-layer-' + jCheckboxElement.data( 'layer' ) );
                mch365.booth.jElementBoothCart.addClass( 'hide-layer-' + jCheckboxElement.data( 'layer' ) );
            }
        } );

        
        mch365.booth.jElementBoothContainer
        .on( 'click', '.js-mch365-btn-booth-update', function ( event ) {
            event.preventDefault();
            mch365.booth.cart.action.updateOrderlines()
        } );
        
        jQuery(document).on('click', '.js-mch365-booth-accept-btn', function (event) {
            mch365.booth.cart.action.updateOrderlines();
        });

        jQuery( window ).on( 'resize', function () {
            if(mch365.booth.feed !== null){
                clearTimeout( mch365.booth.const.resizeInterval );
                mch365.booth.const.resizeInterval = setTimeout( mch365.booth.container.action.calibrate, 200 );
            }
        } );
        //mch365.booth.cart.action.generateImage()
        jQuery('*[data-target="#js-mch365-booth-modal"]').removeClass('d-none');
    },
    container: {
        action: {
            createBooth: function () {
                mch365.booth.jElementBoothCanvas.draggable( {
                    iframeFix: true,
                    refreshPositions: true
                } );
                mch365.booth.container.action.zoom( 1 );
                mch365.booth.container.action.buildLegends();
            },
            zoom: function ( intScale ) {
                mch365.booth.scale = intScale;
                mch365.booth.container.action.calibrate();
            },
            changeContainment: function () {
                let intWidthBoothCanvas = mch365.booth.jElementBooth.width(); //C
                let intHeightBoothCanvas = mch365.booth.jElementBooth.height(); //C
                let intWidthBoothCanvasContainer = intWidthBoothCanvas / mch365.booth.scale; //A
                let intHeightBoothCanvasContainer = intHeightBoothCanvas / mch365.booth.scale; //A
                mch365.booth.jElementBoothCanvasContainer.width( intWidthBoothCanvasContainer );
                let offsetBoothCanvasContainer = mch365.booth.jElementBoothCanvasContainer.offset();
                let x1, y1, x2, y2;

                x1 = intWidthBoothCanvasContainer - intWidthBoothCanvas + offsetBoothCanvasContainer.left;
                y1 = intHeightBoothCanvasContainer - intHeightBoothCanvas + offsetBoothCanvasContainer.top;
                x2 = offsetBoothCanvasContainer.left;
                y2 = offsetBoothCanvasContainer.top;
                let arrContainment = [x1, y1, x2, y2];
                mch365.booth.container.action.setBoothCanvasContainment( arrContainment );
            },
            setBoothCanvasContainment: function ( arrContainment ) {
                mch365.booth.container.action.setBoothCanvasPosition( mch365.booth.jElementBoothCanvas.draggable( 'option', 'containment' ), arrContainment );
                mch365.booth.jElementBoothCanvas.draggable( 'option', 'containment', arrContainment );
            },
            setBoothCanvasPosition: function ( arrOldContainment, arrNewContainment ) {
                let initialTop, initialLeft, x1, y1, x2, y2, newX1, newY1, newX2, newY2;
                x1 = arrOldContainment[ 0 ];
                y1 = arrOldContainment[ 1 ];
                x2 = arrOldContainment[ 2 ];
                y2 = arrOldContainment[ 3 ];

                newX1 = arrNewContainment[ 0 ];
                newY1 = arrNewContainment[ 1 ];
                newX2 = arrNewContainment[ 2 ];
                newY2 = arrNewContainment[ 3 ];

                let containmentWidth = x2 - x1;
                let canvasOffsetLeft = x2 - mch365.booth.jElementBoothCanvas.offset().left;
                let xPct = ( 100 / containmentWidth ) * canvasOffsetLeft;
                xPct = isNaN( xPct ) || arrOldContainment === false || xPct === -Infinity ? 50 : xPct;

                let containmentHeight = y2 - y1;
                let canvasOffsetTop = y2 - mch365.booth.jElementBoothCanvas.offset().top;
                let yPct = ( 100 / containmentHeight ) * canvasOffsetTop;
                yPct = isNaN( yPct ) || arrOldContainment === false || xPct === -Infinity ? 50 : yPct;

                initialTop = ( ( newY2 - newY1 ) / 100 * yPct );
                initialLeft = ( ( newX2 - newX1 ) / 100 * xPct );
                mch365.booth.jElementBoothCanvas.css( {
                    'left': -initialLeft,
                    'top': -initialTop
                } );
            },
            calibrate: function () {
                mch365.booth.expandedElements = [];
                mch365.booth.jElementBoothCart.find('div[data-toggle="collapse"][aria-expanded="true"]').each(function(intIndex, domElement){
                    mch365.booth.expandedElements.push(jQuery(domElement).data('productid'));
                });
                
                mch365.booth.jElementBooth.empty();
                let originalBoothContainerWidth = mch365.booth.jElementBoothContainer.width() * mch365.booth.scale;
                let boothMinimumWidth = mch365.booth.feed.cart.booth.gutter.right + mch365.booth.feed.cart.booth.gutter.left + mch365.booth.feed.cart.booth.width;
                let boothMinimumHeight = mch365.booth.feed.cart.booth.gutter.top + mch365.booth.feed.cart.booth.gutter.bottom + mch365.booth.feed.cart.booth.height;
                let boothLength = boothMinimumWidth < boothMinimumHeight ? boothMinimumHeight : boothMinimumWidth;
                let totalWidthUnits = mch365.booth.const.unitsPerMeter * boothLength;
                
                if ( mch365.booth.feed.cart.booth.width <= mch365.booth.feed.cart.booth.height ){
                    mch365.booth.feed.cart.booth.gridUnitSize = Math.floor((originalBoothContainerWidth / totalWidthUnits) * mch365.booth.const.canvasRatio);
                    mch365.booth.jElementBooth.height( mch365.booth.feed.cart.booth.gridUnitSize * totalWidthUnits + 1 );
                } else {
                    mch365.booth.feed.cart.booth.gridUnitSize = Math.floor( originalBoothContainerWidth / totalWidthUnits );
                    mch365.booth.jElementBooth.width( mch365.booth.feed.cart.booth.gridUnitSize * totalWidthUnits + 1 );
                }
                
                mch365.booth.root.style.setProperty( '--booth-scale', mch365.booth.scale );
                mch365.booth.root.style.setProperty( '--booth-units-per-meter', `${mch365.booth.const.unitsPerMeter}` );
                mch365.booth.root.style.setProperty( '--booth-grid-unit-size', `${mch365.booth.feed.cart.booth.gridUnitSize}px` );
                mch365.booth.container.action.changeContainment();
                mch365.booth.container.action.appendItems();
                mch365.booth.cart.action.buildCart();
                mch365.booth.container.action.placeFloorplan();
            },
            placeFloorplan: function () {
                mch365.booth.variables.floorplan.width = mch365.booth.const.unitsPerMeter * mch365.booth.feed.cart.booth.width * mch365.booth.feed.cart.booth.gridUnitSize + 1;
                mch365.booth.variables.floorplan.height = mch365.booth.const.unitsPerMeter * mch365.booth.feed.cart.booth.height * mch365.booth.feed.cart.booth.gridUnitSize + 1;
                let xFloor = Math.floor( ( mch365.booth.jElementBooth.width() - mch365.booth.variables.floorplan.width ) / 2 );
                xFloor = xFloor - ( xFloor % mch365.booth.feed.cart.booth.gridUnitSize );
                let yFloor = Math.floor( ( mch365.booth.jElementBooth.height() - mch365.booth.variables.floorplan.height ) / 2 );
                yFloor = yFloor - ( yFloor % mch365.booth.feed.cart.booth.gridUnitSize );

                mch365.booth.variables.floorplan.x = xFloor;
                mch365.booth.variables.floorplan.y = yFloor;
                mch365.booth.root.style.setProperty( '--booth-floorplan-top', `${mch365.booth.variables.floorplan.y}px` );
                mch365.booth.root.style.setProperty( '--booth-floorplan-left', `${mch365.booth.variables.floorplan.x}px` );
                mch365.booth.root.style.setProperty( '--booth-floorplan-width', `${mch365.booth.variables.floorplan.width}px` );
                mch365.booth.root.style.setProperty( '--booth-floorplan-height', `${mch365.booth.variables.floorplan.height}px` );
            },
            buildLegends: function () {
                let data = {
                    layer1: [],
                    layer2: [],
                    layer3: []
                };
                jQuery.each( mch365.booth.feed.cart.orderLines, function ( intIndex, orderline ) {
                    if ( orderline.product.layer === '1' && orderline.product.icon !== '' && data.layer1.filter( function ( ol ) { return ol.product.icon === orderline.product.icon; } ).length === 0 ) {
                        data.layer1.push( orderline );
                    }
                    else if ( orderline.product.layer === '2' && orderline.product.icon !== '' && data.layer2.filter( function ( ol ) { return ol.product.icon === orderline.product.icon; } ).length === 0 ) {
                        data.layer2.push( orderline );
                    }
                    else if ( orderline.product.layer === '3' && orderline.product.icon !== '' && data.layer3.filter( function ( ol ) { return ol.product.icon === orderline.product.icon; } ).length === 0 ) {
                        data.layer3.push( orderline );
                    }
                } );
                mch365.booth.jElementBoothLegends.html( e4.handlebars.tmpl.boothLegends( data ) );
            },
            makeItemsDraggable: function () {
                mch365.booth.jElementBooth.find( '.js-mch365-booth-item:not(.ui-draggable-handle)' ).draggable( {
                    containment: '#js-mch365-booth',
                    stack: '.js-mch365-booth-item',
                    grid: [mch365.booth.feed.cart.booth.gridUnitSize, mch365.booth.feed.cart.booth.gridUnitSize],
                    create: function ( event, ui ) {
                        let jElement = jQuery( event.target );
                        let itemHeight = mch365.booth.feed.cart.booth.gridUnitSize * jElement.data( 'yRatio' );
                        let itemWidth = mch365.booth.feed.cart.booth.gridUnitSize * jElement.data( 'xRatio' );
                        let initialTop = mch365.booth.feed.cart.booth.gridUnitSize * jElement.data( 'y' );
                        let initialLeft = mch365.booth.feed.cart.booth.gridUnitSize * jElement.data( 'x' );
                        ui.position = { top: initialTop, left: initialLeft };
                        jElement.css( {
                            'left': initialLeft,
                            'top': initialTop,
                            'width': itemWidth,
                            'height': itemHeight
                        } );
                        mch365.booth.item.action.rotate( jElement, jElement.data( 'rotation' ), jElement.data( 'rotation' ) );
                    },
                    start: function ( event, ui ) {
                        mch365.booth.jElementBooth.find( '.js-mch365-booth-item' ).removeClass( 'active' );
                        jQuery( event.target ).addClass( 'active' );
                    },
                    stop: function ( event, ui ) {
                        let strOrderLineId = jQuery( event.target ).data( 'orderlineid' );
                        mch365.booth.item.action.updateItemInJson( event, ui, strOrderLineId, true );
                    }
                } );
            },
            appendItems: function () {
                jQuery.each( mch365.booth.feed.cart.orderLines, function ( intIndex, objOrderLine ) {
                    if ( objOrderLine.placed ) {
                        mch365.booth.item.action.appendItem( objOrderLine );
                    }
                } );
                mch365.booth.container.action.makeItemsDraggable();
                mch365.booth.cart.action.makeBoothCartItemsDroppable();
            }
        }
    },
    cart: {
        action: {
            ajax: function ( objAjaxSettings, fnCallback ) {
                let jCart = jQuery( '.js-e-cart' ),
                    jqXHR = jQuery.ajax( jQuery.extend( {
                        url: e4.settings.ecom.booth.url,
                        method: 'POST',
                        dataType: 'json',
                        cache: false
                    }, objAjaxSettings ) );
                jqXHR.done( function ( data ) {
                    if ( typeof fnCallback === 'function' ) {
                        fnCallback( data );
                    }
                } );
            },
            load: function () {
                mch365.booth.cart.action.ajax( {
                    method: 'GET',
                    beforeSend: function () {
                        jQuery('#js-mch365-booth-modal').find('.js-booth-cart-preloader').addClass( 'is-loading' );
                    }
                }, function ( jsonData ) {
                    jsonData.cart.orderLines = jsonData.cart.orderLines.filter( function ( orderline ) {return orderline.product.placeable; } );
                    if ( jsonData.cart.orderLines.length > 0 ) {
                        mch365.booth.feed = jsonData;
                        mch365.booth.originalFeedStringified = JSON.stringify( mch365.booth.feed );
                        mch365.booth.jsonChanged = false;
                        mch365.booth.cart.action.buildHeader();
                        mch365.booth.container.action.createBooth();
                    } else {
                        jQuery('#js-mch365-booth-cart-container').html(e4.handlebars.partial.noBoothOrOrderlinesPartial())
                    }
                    jQuery('.js-booth-cart-preloader').removeClass( 'is-loading' );
                } );
            },
            updateOrderlines: function () {
                if ( mch365.booth.jsonChanged ) {
                    let postData = {};
                    postData[ 'CartCmd' ] = 'updateorderlines';
                    postData[ 'OrderContext' ] = 'Booth';
                    postData[ 'Redirect' ] = 'false';
                    jQuery.each( mch365.booth.feed.cart.orderLines, function ( intIndex, orderline ) {
                        if ( orderline.product.placeable ) {
                            let objOriginalOrderline = mch365.booth.item.action.getOriginalOrderline( orderline.id );
                            let objOrderline = mch365.booth.item.action.getOrderline( orderline.id );
                            if ( JSON.stringify( objOriginalOrderline ) !== JSON.stringify( objOrderline ) ) {
                                postData[ `OrderLineFieldValue_${orderline.id}_OrderlineBoothPlaced` ] = orderline.placed ? 1 : 0;
                                postData[ `OrderLineFieldValue_${orderline.id}_OrderlineBoothXPosition` ] = orderline.coords.x;
                                postData[ `OrderLineFieldValue_${orderline.id}_OrderlineBoothYPosition` ] = orderline.coords.y;
                                postData[ `OrderLineFieldValue_${orderline.id}_OrderlineBoothItemRotation` ] = orderline.boothItem.rotation;
                                postData[ `OrderLineFieldValue_${orderline.id}_OrderlineBoothItemCanvasXCoord` ] = orderline.boothItem.x;
                                postData[ `OrderLineFieldValue_${orderline.id}_OrderlineBoothItemCanvasYCoord` ] = orderline.boothItem.y;
                                postData[ `OrderLineFieldValue_${orderline.id}_OrderlineComment`] = orderline.comment;
                            }
                        }
                    } );
                    mch365.booth.cart.action.ajax( {
                        data: postData
                    }, function ( jsonData ) {
                        mch365.booth.originalFeedStringified = JSON.stringify( jsonData );
                        mch365.booth.jsonChanged = false;
                        jQuery('#js-mch365-booth-modal').modal('hide');
                        location.reload();
                    } );
                }
                else {
                    jQuery('#js-mch365-booth-modal').modal('hide');
                }
            },
            generateImage: function(){
                e4.require.js( e4.settings.require.html2canvas, function () {
                    var divToCapture = document.getElementById("js-mch365-booth-panzoom-canvas");
                    html2canvas(divToCapture).then(function(canvas) {
                        var dataURL = canvas.toDataURL("image/png");
                        var link = document.createElement("a");
                        link.href = dataURL;
                        link.download = "div_image.png";
                        link.click();
                    });
                } );
            },
            buildHeader: function(){
                jQuery('.js-mch365-booth-cart-header').html( e4.handlebars.tmpl.boothCartHeader( mch365.booth.feed ) );
            },
            buildCart: function () {
                let data = {
                    notplaced: [],
                    placed: []
                };
                let productsInCollection = [];
                let placedProductsInCollection = [];

                jQuery.each( mch365.booth.feed.cart.orderLines, function ( intIndex, orderline ) {
                    let strOrderline = JSON.stringify( orderline );
                    let objOrderline = JSON.parse( strOrderline );
                    if ( objOrderline.product.placeable ) {
                        if ( objOrderline.placed ) {
                            objOrderline.collection = [];
                            if ( placedProductsInCollection.indexOf( objOrderline.product.id ) === -1 ) {
                                let productCollection = mch365.booth.feed.cart.orderLines.filter( function ( ol ) {
                                    return objOrderline.product.id === ol.product.id && ol.placed === true;
                                } );
                                placedProductsInCollection.push( objOrderline.product.id );
                                objOrderline.collection = productCollection;
                                objOrderline.expanded = mch365.booth.expandedElements.indexOf(objOrderline.product.id) > -1;
                                data.placed.push( objOrderline );
                            }
                        }
                        else {
                            objOrderline.collectionCount = null;
                            if ( productsInCollection.indexOf( objOrderline.product.id ) === -1 ) {
                                let productCollection = mch365.booth.feed.cart.orderLines.filter( function ( ol ) {
                                    return objOrderline.product.id === ol.product.id && ol.placed === false;
                                } );
                                productsInCollection.push( objOrderline.product.id );
                                objOrderline.collectionCount = productCollection.length > 1 ? productCollection.length : null;
                                data.notplaced.push( objOrderline );
                            }
                        }
                    }
                } );
                mch365.booth.jElementBoothCart.html( e4.handlebars.tmpl.boothCart( data ) );
                mch365.booth.cart.action.makeBoothCartItemsDroppable();
            },
            makeBoothCartItemsDroppable: function () {
                mch365.booth.jElementBooth.droppable( {
                    accept: '.js-mch365-booth-cart-droppable-item',
                    drop: function ( event, ui ) {
                        let strOrderLineId = ui.helper.prevObject.closest( '.js-mch365-booth-cart-item' ).data( 'orderlineid' );
                        mch365.booth.item.action.updateItemInJson( event, ui, strOrderLineId, true );
                    }
                } );
                mch365.booth.jElementBoothCart.find( '.js-mch365-booth-cart-droppable-item' ).draggable( {
                    helper: 'clone',
                    containment: '.js-mch365-booth-cart-container',
                    start: function ( event, ui ) {
                        ui.helper.addClass( 'moving' );
                        jQuery( event.target ).addClass( 'd-none' );
                    },
                    stop: function ( event, ui ) {
                        jQuery( event.target ).removeClass( 'd-none' );
                    }
                } );
            }
        }
    },
    item: {
        action: {
            getOrderline: function ( strOrderLineId ) {
                return mch365.booth.feed.cart.orderLines.filter( function ( orderline ) {
                    return orderline.id === strOrderLineId;
                } );
            },
            getOriginalOrderline: function ( strOrderLineId ) {
                let originalFeed = JSON.parse( mch365.booth.originalFeedStringified );
                return originalFeed.cart.orderLines.filter( function ( orderline ) {
                    return orderline.id === strOrderLineId;
                } );
            },
            updateItemInJson: function ( event, ui, strOrderLineId, recalibrate ) {
                let orderline = mch365.booth.item.action.getOrderline( strOrderLineId );
                let xPos = ui.offset.left - mch365.booth.jElementBooth.offset().left;
                let yPos = ui.offset.top - mch365.booth.jElementBooth.offset().top;
                let xCoord = ( Math.round( ( xPos - mch365.booth.variables.floorplan.x ) / mch365.booth.feed.cart.booth.gridUnitSize ) / mch365.booth.const.unitsPerMeter ).toFixed( 1 );
                let yCoord = ( Math.round( ( yPos - mch365.booth.variables.floorplan.y ) / mch365.booth.feed.cart.booth.gridUnitSize ) / mch365.booth.const.unitsPerMeter ).toFixed( 1 );

                let intIndex = mch365.booth.feed.cart.orderLines.indexOf( orderline[ 0 ] );
                mch365.booth.feed.cart.orderLines[ intIndex ].coords.x = xCoord;
                mch365.booth.feed.cart.orderLines[ intIndex ].coords.y = yCoord;
                mch365.booth.feed.cart.orderLines[ intIndex ].boothItem.x = Math.round( xPos / mch365.booth.feed.cart.booth.gridUnitSize );
                mch365.booth.feed.cart.orderLines[ intIndex ].boothItem.y = Math.round( yPos / mch365.booth.feed.cart.booth.gridUnitSize );
                mch365.booth.feed.cart.orderLines[ intIndex ].boothItem.rotation = jQuery( event.target ).data( 'rotation' );
                mch365.booth.feed.cart.orderLines[ intIndex ].placed = true;
                if ( recalibrate ) {
                    mch365.booth.container.action.calibrate();
                }
                mch365.booth.jsonChanged = true;
            },
            rotate: function ( jElement, prevDegree, degree, recalibrate ) {
                degree = degree.length === 0 ? 0 : degree;
                let orderline = mch365.booth.item.action.getOrderline( jElement.data( 'orderlineid' ) );
                let intIndex = mch365.booth.feed.cart.orderLines.indexOf( orderline[ 0 ] );
                const originalWidth = mch365.booth.feed.cart.orderLines[ intIndex ].product.ratio.x * mch365.booth.feed.cart.booth.gridUnitSize;
                const originalHeight = mch365.booth.feed.cart.orderLines[ intIndex ].product.ratio.y * mch365.booth.feed.cart.booth.gridUnitSize;
                let boothItem = document.querySelector( `.booth-item-dimensions-${jElement.data( 'orderlineid' )}` )

                if ( degree === 0 || degree === 180 ) {
                    jElement[ 0 ].style.height = `${originalHeight}px`;
                    jElement[ 0 ].style.width = `${originalWidth}px`;
                    boothItem.style.setProperty( '--booth-item-width', `${originalWidth}px` );
                    boothItem.style.setProperty( '--booth-item-height', `${originalHeight}px` );
                }
                else {
                    jElement[ 0 ].style.height = `${originalWidth}px`;
                    jElement[ 0 ].style.width = `${originalHeight}px`;
                    boothItem.style.setProperty( '--booth-item-width', `${originalHeight}px` );
                    boothItem.style.setProperty( '--booth-item-height', `${originalWidth}px` );
                }

                jElement.removeClass( 'deg-' + prevDegree );
                jElement.addClass( 'deg-' + degree );
                jElement.data( 'rotation', degree );
                mch365.booth.feed.cart.orderLines[ intIndex ].boothItem.rotation = jElement.data( 'rotation' );
                if ( recalibrate ) {
                    mch365.booth.jsonChanged = true;
                    mch365.booth.container.action.calibrate();
                }
            },
            appendItem: function ( objOrderLine ) {
                mch365.booth.jElementBooth.append( e4.handlebars.partial.boothItemPartial( objOrderLine ) );
            }
        }
    }
};
